import { toast } from "react-toastify";
import axiosInstance from "../../../../axiosInstance";
import { HRMS_FINANCE_API_URL } from "../../../Constants/baseConstant";
import { getDomain, getUserId } from "../../Base/helper/baseFunctions";
import NProgress from "nprogress";

export const GetExpenseTypeHelper = async (params) => {
  NProgress.start();
  return await axiosInstance(`/finance/getExpenseType`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      expense_type_fk: params?.expense_type_fk || null,
    },
  })
    .then((res) => {
      NProgress.done();
      return {
        message: "Expense types retrieved successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      NProgress.done();
      return {
        message: "Unable to retrieve expense types",
        hasError: true,
        data: err?.response?.data,
      };
    });
};

export const AddExpenseTypeHelper = async (params) => {
  toast.dismiss();
  toast.info("Saving...");
  return await axiosInstance(`/finance/addExpenseType`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      user_id: getUserId(),
      expense_name: params?.expense_type_name,
      },
  })
    .then((res) => {
      toast.dismiss();
      toast.success("Expense type added successfully");
      return {
        message: "Expense type added successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      toast.dismiss();
      toast.error(err?.response?.data?.error?.[0]?.message);
      return {
        message: "Unable to add expense type",
        hasError: true,
        data: err?.response?.data,
      };
    });
};

export const UpdateExpenseTypeHelper = async (params) => {
  toast.dismiss();
  toast.info("Saving...");
  return await axiosInstance(`/finance/updateExpenseType`, {
    method: "PUT",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      user_id: getUserId(),
      expense_type_id: params?.expense_type_id,
      expense_name: params?.expense_type_name,
      proof_approval_required: params?.proof_approval_required,
      approver_executive_employee_fk: params?.approver_executive_employee_fk || null,
    },
  })
    .then((res) => {
      toast.dismiss();
      toast.success("Expense type updated successfully");
      return {
        message: "Expense type updated successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      toast.dismiss();
      toast.error(err?.response?.data?.error?.[0]?.message);
      return {
        message: "Unable to update expense type",
        hasError: true,
        data: err?.response?.data,
      };
    });
};
export const DeleteExpenseTypeHelper = async (params) => {
  toast.dismiss();
  toast.info("Deleting...");
  return await axiosInstance(`/finance/deleteExpenseType`, {
    method: "DELETE",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      expense_type_id: params?.expense_type_id,
    },
  })
    .then((res) => {
      toast.dismiss();
      toast.success("Expense type deleted successfully");
      return {
        message: "Expense type deleted successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      toast.dismiss();
      toast.error(err?.response?.data?.error?.[0]?.message);
      return {
        message: "Unable to delete expense type",
        hasError: true,
        data: err?.response?.data,
      };
    });
};

// ---------- EXPENSE SUBTYPE HELPERS ----------

export const GetExpenseSubtypeHelper = async (params) => {
  return await axiosInstance(`/finance/getExpenseSubtype`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      expense_type_id: params?.expense_type_id || null
    },
  })
    .then((res) => {
      return {
        message: "Expense subtypes retrieved successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      return {
        message: "Unable to retrieve expense subtypes",
        hasError: true,
        data: err?.response?.data,
      };
    });
};

export const AddExpenseSubtypeHelper = async (params) => {
  toast.dismiss();
  toast.info("Saving...");
  return await axiosInstance(`/finance/addExpenseSubtype`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      user_id: getUserId(),
      expense_type_id: params?.expense_type_id?.expense_type_id,
      sub_expense_type_name: params?.sub_expense_type_name,
      proof_approval_required: params?.proof_approval_required || false,
      approver_executive_employee_fk: params?.proof_approval_required === true ? params?.approver_executive_employee_fk?.employee_id : null,
    },
  })
    .then((res) => {
      toast.dismiss();
      toast.success("Expense configuration added successfully");
      return {
        message: "Expense configuration added successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      toast.dismiss();
      toast.error(err?.response?.data?.error?.[0]?.message);
      return {
        message: "Unable to add expense",
        hasError: true,
        data: err?.response?.data,
      };
    });
};

export const UpdateExpenseSubtypeHelper = async (params) => {
  toast.dismiss();
  toast.info("Saving...");
  return await axiosInstance(`/finance/updateExpenseSubtype`, {
    method: "PUT",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      user_id: getUserId(),
      sub_expense_type_id: params?.sub_expense_type_id,
      sub_expense_type_name: params?.sub_expense_type_name,
      expense_type_id: params?.expense_type_id?.expense_type_id,
      proof_approval_required: params?.proof_approval_required || false,
      approver_executive_employee_fk: params?.proof_approval_required === true ? params?.approver_executive_employee_fk?.employee_id : null,
    },
  })
    .then((res) => {
      toast.dismiss();
      toast.success("Expense configuration updated successfully");
      return {
        message: "Expense configuration updated successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      toast.dismiss();
      toast.error(err?.response?.data?.error?.[0]?.message);
      return {
        message: "Unable to update expense",
        hasError: true,
        data: err?.response?.data,
      };
    });
};

export const DeleteExpenseSubtypeHelper = async (params) => {
  toast.dismiss();
  toast.info("Deleting...");
  return await axiosInstance(`/finance/deleteExpenseSubtype`, {
    method: "DELETE",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      sub_expense_type_id: params?.sub_expense_type_id,
    },
  })
    .then((res) => {
      toast.dismiss();
      toast.success("Expense configuration deleted successfully");
      return {
        message: "Expense configuration deleted successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      toast.dismiss();
      toast.error(err?.response?.data?.error?.[0]?.message);
      return {
        message: "Unable to delete expense",
        hasError: true,
        data: err?.response?.data,
      };
    });
};
